export const enableAutoRefillRequestDefault = '{\n' +
    '    "daysSupply": "30",\n' +
    '    "drugId": "",\n' +
    '    "personId": "",\n' +
    '    "profileId": "",\n' +
    '    "prescriptionId": "",\n' +
    '    "priceSelectionPreference": "LowestPrice"\n' +
    '}';

export interface IEnableAutoRefillRequest {
    daysSupply: number,
    drugId: string,
    personId: string,
    profileId: string,
    prescriptionId: string,
    priceSelectionPreference: string
}